import { createAction } from 'redux-actions';
export const submitStatus = createAction('STATUS.SUBMIT', (payload)=>payload);
export const submitStatusFailure = createAction('STATUS.SUBMIT.FAILURE', (payload)=>payload);
export const submitStatusFailureDismiss = createAction('STATUS.SUBMIT.FAILURE.DISMISS', ()=>({}));
export const submitStatusSuccess = createAction('STATUS.SUBMIT.SUCCESS', (payload)=>payload);
export const deleteStatus = createAction('STATUS.DELETE', (payload)=>payload);
